import { render, staticRenderFns } from "./modalVideoTour.vue?vue&type=template&id=25e3f003&scoped=true"
import script from "./modalVideoTour.vue?vue&type=script&lang=js"
export * from "./modalVideoTour.vue?vue&type=script&lang=js"
import style0 from "./modalVideoTour.vue?vue&type=style&index=0&id=25e3f003&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3f003",
  null
  
)

export default component.exports